
export const categories = [
    "First Action Interview Pilot",
    "Amendment",
    "Application Part",
    "Change Requests",
    "Change Requests - Supp Exam",
    "Continued Prosecution",
    "Entity Status Correspondence",
    "Eprocessing",
    "General Transmittal",
    "General Transmittal - Supp Exam",
    "IDS/References",
    "Items of Information - Other Specific",
    "Office of Patent Pub",
    "PCT - Amendment",
    "PCT - Application Part",
    "PCT - Change Request",
    "PCT - Chapter II",
    "PCT - Form",
    "PCT - General Transmittal",
    "PCT - Petition",
    "Petition",
    "Pilot Programs",
    "Pre-Exam",
    "Pre-Grant Pub",
    "Priority Documents",
    "PTAB",
    "PTAB Petition",
    "PTAB Reexamination",
    "Reexamination",
    "Reissue",
    "SE (Items of Information)",
    "Supplemental Examination",
    "Track I - Prioritized Examination",
    "1.501 Prior Art Submission"
]

export const categoriesSubCategoriesMap = {
    "First Action Interview Pilot": [
        "Reply under 37 CFR 1.111 to Pre-Interview Communication",
        "First action interview - Enrollment Request",
        "First Action Interview - Schedule Interview Request",
        "Request to Not Have a First Action Interview",
        "Amendment/Request for Reconsideration-After Non-Final Rejection"
    ],
    "Amendment": [
        "Amendment after Notice of Allowance (Rule 312)",
        "Response After Final Action",
        "Preliminary Amendment",
        "Response after Ex Parte Quayle Action",
        "Abstract",
        "Amendment Submitted/Entered with Filing of CPA/RCE",
        "Amendment/Argument after Notice of Appeal",
        "Amendment/Argument after BPAI Decision",
        "Request for Rehearing of BPAI Decision",
        "Claims",
        "Drawings-only black and white line drawings",
        "Drawings-other than black and white line drawings",
        "Electronic Record Correction",
        "Response to Election / Restriction Filed",
        "Amendment Copying Claims - Not in Response to Examiner Suggesting Claims",
        "Amendment Copy Claims/Response to Suggested Claims",
        "Applicant summary of interview with examiner",
        "Request under Rule 48 correcting inventorship",
        "Request for Continued Examination (RCE)",
        "Applicant Arguments/Remarks Made in an Amendment",
        "Supplemental Response or Supplemental Amendment",
        "Specification",
    ],
    "Application Part": [
        "Documents submitted with 371 (National Stage) Applications",
        "Abstract",
        "Application Data Sheet",
        "Chemical Formulae (Text File)",
        "Mathematical Formulae (Text File)",
        "3D Protein Crystals (Text File)",
        "Appendix to the Specification",
        "Claims",
        "Computer Listing (text file)",
        "Terminal Disclaimer Filed",
        "Drawings-only black and white line drawings",
        "Drawings-other than black and white line drawings",
        "Translation of Foreign Priority Documents",
        "Miscellaneous Incoming Letter",
        "Oath or Declaration filed",
        "Power to Make Copies and/or Inspect",
        "Sequence Listing (Text File)",
        "Sequence Listing",
        "Specification",
        "Specification - Not in English",
        "Statutory disclaimers per Manual of Patent Examining Procedure(MPEP) 1490.",
        "Table not included in Specification (Text File)",
        "Provisional Cover Sheet (SB16)",
        "Fee Worksheet (SB06)",
        "Interim Copy of the Foreign Priority Document",
        "Interim Copy of the Foreign Priority Document (text file)",
        "Affidavit-Rule 130(a)-America Invents Act (First Inventor to File) ONLY",
        "Affidavit-Rule 130(b)-America Invents Act (First Inventor to File) ONLY",
        "Affidavit-Rule 131-pre-America Invents Act (First to Invent) ONLY",
        "Affidavit-traversing rejections or objections rule 132",
        "Affidavit-not covered under specific rule",
        "Make/Rescind America Invents Act(AIA) (First Inventor to File) 1.55/1.78 Statement",
        "Annex(es) to DM/1 or equivalent",
        "Application for International Registration (DM/1 or equivalent)"
    ],
    "Change Requests": [
        "Change of Address",
        "Response to Rule 105 Communication",
        "List-up to 10 attys appointed in a POA",
        "Power to Make Copies and/or Inspect",
        "Electronic Record Correction",
        "Request for withdrawal as attorney or agent",
        "Power of Attorney",
        "Maintenance Fee Address Change"
    ],
    "Change Requests - Supp Exam": [
        "Change of Address",
        "Electronic Record Correction",
        "Request for withdrawal as attorney or agent",
        "Power of Attorney",
        "Request for Certificate of Correction"
    ],
    "Continued Prosecution": [
       "Continued Prosecution Application - Continuation (Amendment CPA)",
        "Amendment Submitted/Entered with Filing of Continued Prosecution Application (CPA)/Request for Continued Examination (RCE)",
        "Continuing Prosecution Application - Divisional (DCPA)",
        "Request for Continued Examination (RCE)"
    ],
    "Entity Status Correspondence": [
        "Certification of Micro Entity (Gross Income Basis)",
        "Certification of Micro Entity (Education Basis)",
        "Assertion of entitlement to small entity status",
        "Notification of loss of entitlement to small entity status",
        "Notification of loss of entitlement to micro entity status"
    ],
    "Eprocessing" :[
        "Evidence of Publication",
        "Concise Description of Relevance",
        "Translation - Foreign Reference",
        "Translation - Non Patent Literature"
    ],
    "General Transmittal": [
        "Authorization for Extension of Time all replies",
        "English translation of non-English PCT publication for provisional rights under 35 U.S.C. 154(d)",
        "Request for extension under COVID-19",
        "Response to Rule 105 Communication",
        "Internet Communications Authorized",
        "Internet Communications Authorization Withdrawn",
        "Computer Readable Form (CRF) Statement Paper and Computer Readable Form are the same",
        "Letter Express Abandonment of the application",
        "Petition for Expedited Foreign Filing Licenses",
        "First action interview - Enrollment Request",
        "Request to Not Have a First Action Interview",
        "Issue Fee Payment (PTO-85B)",
        "Applicant summary of interview with examiner",
        "Any request going to Licensing and Review",
        "Miscellaneous Incoming Letter",
        "Letter Requesting Suspension of Prosecution",
        "Letter Requesting Interview with Examiner",
        "Post Allowance Communication - Incoming",
        "Transmittal Letter accompanying New/Additional Drawings",
        "Power of Attorney",
        "List-up to 10 attorneys appointed in a POA",
        "Relief in Emergency Situations Determined by Director",
        "Statement of preexamination search",
        "Examination support document",
        "Request under Rule 129 to Reopen Prosecution",
        "Response providing copy of record for reconstruction",
        "Assignee showing of ownership per 37 CFR 3.73",
        "Refund Request",
        "Refund Request ONLY for Papers Filed During a Designated Outage",
        "Request for Expedited Processing, Design Rocket Docket",
        "Supplemental Response or Supplemental Amendment",
        "Form PTO/SB/94 - Statutory Invention Registration (SIR) Request",
        "Authorization or Rescission of Authorization to Access Search Results",
        "Request for status of Application",
        "Election in Response to Notice of Final Determination",
        "Response to request for information sent under 37 CFR 1.750",
        "37 CFR 1.750 Request for reconsideration",
        "Patent Term Extension Application Under 35 USC 156",
        "Interim Patent Term Extension Application Under 35 USC 156(d)(5)",
        "Patent Term Extension (PTE) Waiver of time period for requesting reconsideration",
        "Withdrawal of Application for Patent Term Extension (PTE)",
        "Provisional Cover Sheet (SB16)",
        "Accelerated Exam - Transmittal amendment/reply",
        "Transmittal Reissue Application",
        "Fee Worksheet (SB06)",
        "Extension of Time",
        "Relief in Emergency Situations Determined by Director",
        "Pro Bono Representation Certification",
        "Assignee showing of ownership per 37 CFR 3.73",
        "Fee Worksheet (PTO-06)",
        "Miscellaneous Incoming Letter",
        "Power of Attorney",
        "Power to Make Copies and/or Inspect",
        "Refund Request",
        "Transmittal Letter",
        "Transmittal of New Application",
        "Certification of Pro Bono Representation"
    ],
    "General Transmittal - Supp Exam": [
        "Assignee showing of ownership per 37 CFR 3.73",
        "Fee Worksheet (PTO-06)",
        "List-up to 10 attys appointed in a POA",
        "Miscellaneous Incoming Letter",
        "Power of Attorney",
        "Power to Make Copies and/or Inspect",
        "Refund Request",
        "Transmittal Letter",
        "Transmittal of New Application",
        "Certification of Pro Bono Representation"  
    ],
    "IDS/References": [
        "Third-Party Submission under 37 CFR 1.290",
        "Foreign Reference",
        "Information Disclosure Statement (IDS) Form (SB08)",
        "Letter specifying the conditions for filing under 37 CFR 1.97",
        "Non Patent Literature",
        "37 CFR 1.501 Submission by Patent Owner",
        "Other reference - Patent/Application/Search Documents",
        "Patent Term Adjustment Statement under 37 CFR 1.704(d) filed with an IDS",
        "Transmittal Letter"
    ],
    "Items of Information - Other Specific" : [
        "3D Protein Crystals (Text File)",
        "Computer Listing (text file)",
        "Computer Readable Form (CRF) Statement Paper and Computer Readable Form are the same",
        "Mathematical Formulae (Text File)",
        "Request to Voluntarily Supply Lengthy Table",
        "Sequence Listing",
        "Sequence Listing (Text File)"
    ],
    "Office of Patent Pub": [
        "Request for Corrected Notice of Allowance",
        "Request for New or Replacement Patent Grant",
        "Request for Certificate of Correction",
        "Request for Simultaneous Issuance",
        "Nonpublication request from applicant",
        "Rescind Nonpublication Request for Pre Grant Publication"
    ],
    "PCT - Amendment":[
        "Request for Reconsideration - IA",
        "Chapter II - Amendments to description/drawings - PCT Article 34",
        "Chapter II - Amendment to the claims - PCT Article 34",
        "Chapter II - Request for Reconsideration - International Application",
        "Chapter II - Response to the written opinion ISA/237/IPEA/408"
    ],
    "PCT - Application Part": [
        "Request for Reconsideration - IA",
        "Chapter II - Amendments to description/drawings - PCT Article 34",
        "Chapter II - Amendment to the claims - PCT Article 34",
        "Chapter II - Request for Reconsideration - International Application",
        "Chapter II - Response to the written opinion ISA/237/IPEA/408",
        "Abstract",
        "Claims",
        "Drawings-only black and white line drawings",
        "RO/134 - Deposited Microorganisms/Bio Material",
        "Sequence Listing Cover Sheet/Statement under PCT Rule 13ter",
        "Corp. Resolution/Auth to act on behalf of Corp.",
        "Fee payment - International Application",
        "Miscellaneous incoming letter from Applicant - International Application",
        "PCT/RO/101 Annex (fee calculation sheet)",
        "PCT/RO/101 - Request form for new International Application - Conventional",
        "PCT/RO/101 - Request form for new International Application - PCT EASY Format",
        "PCT EASY Validation Log",
        "Statement explaining lack of signature - International Application",
        "PCT-Transmittal Letter",
        "Power of Attorney",
        "Sequence Listing (Text File)",
        "Sequence Listing",
        "Specification"
    ],
    "PCT - Change Request": [
        "Request for recording of a change/PCT Rule 92bis",
        "Confirmation of incorporation by reference",
        "Request for rectification - International Application",
        "Evidence for restore of priority claim",
        "Priority Claim Adjustment under PCT Rule 26bis",
        "Substitute Sheets of Request (Form PCT/RO/101)",
        "Substitute Drawings",
        "Substitute Sheets - International Application",
        "Request to withdraw International Application",
        "Request to withdraw as attorney - International Application",
        "Request to withdraw designation - International Application",
        "Request to withdraw priority claim - International Application",
        "Chapter II - Request for recording change/PCT Rule 92bis",
        "Chapter II - Response to form PCT/IPEA/404",
        "Chapter II - Request to withdraw as attorney - International Application",
        "Chapter II - Request to withdraw designation - International Application",
        "Chapter II - Request to withdraw priority claim - International Application",
        "Power of Attorney"
    ],
    "PCT - Chapter II": [
        "Chapter II - Form PCT/IPEA/401 - Demand",
        "Chapter II - Form IPEA/401 Annex",
        "Chapter II - Request for recording change/PCT Rule 92bis",
        "Chapter II - Amendments to description/drawings - PCT Article 34",
        "Chapter II - Amendment to the claims - PCT Article 34",
        "Chapter II - Fee payment - International Application",
        "Chapter II - Miscellaneous communication from Applicant - International Application",
        "Chapter II - Request for Reconsideration - International Application",
        "Chapter II - Request for rectification - International Application",
        "Chapter II - Response to form PCT/IPEA/404",
        "Chapter II - Response to form PCT/IPEA/405 Unity of Invention",
        "Chapter II - Response to the written opinion ISA/237/IPEA/408",
        "Chapter II - Request to withdraw as attorney - International Application",
        "Chapter II - Request to withdraw designation - International Application",
        "Chapter II - Request to withdraw priority claim - International Application",
        "Chapter II - Petition for review by the PCT legal office"
    ],
    "PCT - Form": [
        "RO/101 - Request form for new IA - Conventional",
        "RO/101 - Request form for new IA - PCT EASY Format",
        "Substitute Sheets of Request (Form PCT/RO/101)",
        "Chapter II - Form PCT/IPEA/401 - Demand",
        "Chapter II - Form IPEA/401 Annex"
    ],
    "PCT - General Transmittal": [
        "Petition for Expedited Foreign Filing Licenses",
        "Sequence Listing Cover Sheet/Statement under PCT Rule 13ter",
        "PCT/ISA/217 - Notification of Decision Request for Rectification",
        "PCT/ISA/224 - Communication-No Other Form is Applicable",
        "PCT/ISA/225 - Invitation to Furnish Nucleotide/Amino Acid/Related Tables",
        "PCT/ISA/234 - Notification of Transmission of Demand to International Bureau (IB) or the Competent IPEA",
        "Corporation Resolution/Authority to Act on Behalf of Corporation",
        "Fee payment - International Application",
        "Miscellaneous communication from ISA",
        "Misc. incoming letter from Applicant - IA",
        "RO/101 - Annex (fee calculation sheet)",
        "Request for Reconsideration - International Application",
        "Response to Form PCT/ISA/206 Unity of Invention",
        "Response to PCT/PCT/ISA/225 invitation to furnish sequence listing",
        "PCT EASY Validation Log",
        "Chapter I – Select Competent International Searching Authority (ISA)",
        "Statement explaining lack of signature - International Application",
        "PCT-Transmittal Letter",
        "Request to withdraw US designation - International Application",
        "Chapter II - Fee payment - International Application",
        "Chapter II - Miscellaneous communication from Applicant - International Application",
        "Chapter II - Request for Reconsideration - International Application",
        "Chapter II - Request for rectification - International Application",
        "Chapter II - Response to form PCT/IPEA/405 Unity of Invention",
        "Power of Attorney",
        "Request for status of Application",
        "Fee Worksheet (PTO-06)",
        "Extension of Time",
        "Certification of Pro Bono Representation"
    ],
    "PCT - Petition": [
        "Petition for Expedited Foreign Filing Licenses",
        "Confirmation of incorporation by reference",
        "Evidence for restore of priority claim",
        "Chapter II - Petition for review by the PCT legal office",
        "Petition for review and processing by the PCT legal office"
    ],
    "Petition": [
        "Petition for Expedited Foreign Filing Licenses",
        "Petition under Rule 41.3 to Chief Admin Patent Judge",
        "Petition automatically granted by EFS",
        "Petition from Applicant to accept color drawings or color photographs",
        "Petition auto-grant letter from EFS",
        "Electronic Record Correction",
        "Petition for review by the Office of Petitions",
        "Petition to make special based on Age/Health",
        "Petition for review by the PCT legal office",
        "Request for withdrawal as attorney or agent",
        "Patent Term Adjustment Petition",
        "Petition for review by the Technology Center Special Program Examiner (SPRE)",
        "Petition for 12-month Accelerated Examination",
        "Petition for review/processing depending on status",
        "Petition to Withdraw from Issue",
        "Petition to make Special under Patent Prosecution Highway",
        "Petition to Convert under 37 CFR 1.53(c)(2) or (c)(3)",
        "Request Acceleration Certificate Humanitarian Program",
        "Petition To Make Special for collaborative search",
        "Petition for collaborative search with JPO",
        "Petition for collaborative search with KIPO",
        "Petition in an International design application decided by International Patent Legal Administration (IPLA)",
        "Petition for Cancer Immunotherapy Pilot"
    ],
    "Pilot Programs": [
        "After Final Consideration Program Request",
        "Green Tech Petition under 37 CFR 1.102",
        "Petition to make special under Patent Prosecution Hwy",
        "Petition to make special by Express Abandonment of Copending Application",
        "Certification and Request for Missing Parts",
        "Request for Peer Review",
        "COVID-19 Prioritized Examination Request",
        "Prosecution Conference Pilot Request"
    ],
    "Pre-Exam": [
        "Request for Corrected Filing Receipt",
        "Request for Peer Review",
        "Applicant Response to Pre-Exam Formalities Notice",
        "Response to Pre-Exam Reissue Notice",
        "Response to Pre-Exam Sequence Notice",
        "Nonpublication request from applicant",
        "Certification and Request for Missing Parts",
        "Rescind Nonpublication Request for Pre Grant Pub"
    ],
    "Pre-Grant Pub": [
        "Request for Early Publication",
        "Request/Corrected Patent Application Publications",
        "Request for Express Abandonment for refund or to avoid publication",
        "Request for Refund of Publication Fee Paid",
        "Rescind Nonpublication Request for Pre Grant Pub"
    ],
    "Priority Documents": [
        "Interim Copy of Foreign Priority Document (PDF)",
        "Interim Copy of Foreign Priority Document (TXT)",
        "Request for USPTO to retrieve priority docs",
        "Authorization or Rescission of Authorization to Access Application by Digital Access Service / Priority Document Exchange Office"
    ],
    "PTAB": [
        "Appeal Brief Filed",
        "Pre-Appeal Brief Conference Request",
        "Amendment/Argument after Notice of Appeal",
        "Request to Withdraw Appeal by Appellant",
        "Affidavit/Declaration/Exhibit After Notice of Appeal",
        "Confirmation of Hearing by Appellant",
        "Request for Oral Hearing",
        "Appeal Postponement of Oral Hearing Request",
        "Reply Brief Filed",
        "Waiver of Hearing by Appellant",
        "Request for Rehearing of BPAI Decision",
        "Petition under Rule 41.3 to Chief Administrative Patent Judge",
        "Certification and Transmittal of Appeal Forwarding Fee",
        "Notice of Appeal Filed",
        "Supplemental Appeal Brief",
        "District Court Trial Documents - Incoming",
        "District Court Trial Exhibit",
        "District Court Trial Pleading",
        "District Court Trial Transcripts",
        "District Court Trial Presentation"
    ],
    
    "PTAB Petition": [
        "Petition under Rule 41.3 to Chief Admin Patent Judge"
    ],
    "PTAB Reexamination": [
        "Withdrawal of Appeal",
        "Request for rehearing to BPAI",
        "Patent Owner Comments on request for Rehearing timely",
        "Requester Comments on request for Rehearing timely"
    ],
    "Reexamination": [
        "Notice of concurrent proceedings / decisions",
        "Notice of Cross Appeal - Third Party Requester",
        "Reexam follow-on papers received in Office of Patent Application Processing (OPAP)",
        "Reexam Response to Final Rejection",
        "Reexam Defective Brief Filed",
        "Reexam Certificate of Mailing",
        "Reexam Certificate of Service",
        "Reexam Court of Appeals Decision Rendered",
        "Reexam Appeal BPAI Decision to Court of Appeals",
        "Reexam Fee Payment Only Filed",
        "Reexam Miscellaneous Incoming Letter",
        "Copy of patent for which reexamination is requested",
        "Petition for Review of Reexam Denial",
        "Reexam request for For Priority (Priority Papers May Be Included)",
        "Request to Merge Reexam Proceedings",
        "Reexam Request to Lift Suspension of Prosecution",
        "Transmittal letter filing of a response in a reexam",
        "Patent Owner Comments after Action Closing Prosecution",
        "Patent Owner Appeal to the Federal Circuit Filed"
    ],
    "Reissue": [
        "Notice of concurrent proceedings / decisions",
        "Consent of Assignee accompanying the declaration",
        "Reissue Oath or Declaration",
        "Supplemental reissue declaration filed in accord with Manual of Patent Examining Procedure (MPEP) 1414.01",
        "Transmittal Reissue Application"
    ],
    "SE (Items of Information)": [
        "Copy of Sales Receipt or Invoice - Supplemental Examination",
        "Court Document - Supplemental Examination",
        "Declaration or Affidavit - Supplemental Examination",
        "Drawings-only black and white line drawings",
        "Drawings-other than black and white line drawings",
        "Foreign Reference",
        "List of Items of Information - Supplemental Examination",
        "Miscellaneous Item of Information",
        "Non Patent Literature",
        "Transcript of Audio or Video Recording - Supplemental Examination",
        "Translation of Non-English Language Item of Information",
        "US Patent or Patent Application Pub - Supp Exam"
    ],
    "Supplemental Examination": [
        "Assignee showing of ownership per 37 CFR 3.73",
        "Copy of patent for which Supplemental Examination is requested",
        "Fee Worksheet (PTO-06)",
        "List of Prior or Concurrent Office Proceedings - Supplemental Examination",
        "List-up to 10 attys appointed in a POA",
        "Petition in Supplemental Examination",
        "Power of Attorney",
        "Receipt of Corrected Supplemental Examination Request",
        "Receipt of Original Supplemental Examination Request"
    ],
    "Track I - Prioritized Examination": [
        "COVID-19 Prioritized Examination Request"
    ],
    "1.501 Prior Art Submission": [
        "Certificate of Service under 37 CFR 1.248",
        "Accompanying Info for patent owner claim scope statement",
        "Patent Owner Claim Scope Statement Explanation/Justification",
        "Patent Owner Claim Scope Statements",
        "Statement(s) of Pertinence and Manner (Prior Art)",
        "Evidence of Publication",
        "Request notice of Non-compliant 37 CFR 1.501 Submission",
        "Translation - Foreign Reference",
        "Translation - Non Patent Literature/Publications"
    ],
};